import React from "react";

import DashBoardImg from "../../images/SideBar/DashBoard";
import DealerImg from "../../images/SideBar/Dealer";
import Document from "../../images/SideBar/Document";
import EmployeeImg from "../../images/SideBar/Employee";
import Goal from "../../images/SideBar/Goal";
import Holiday from "../../images/SideBar/Holiday";
import InfoImg from "../../images/SideBar/Info";
import Lead from "../../images/SideBar/Lead";
import Leave from "../../images/SideBar/Leave";
import Leave2 from "../../images/SideBar/Leave2";
import ProductImg from "../../images/SideBar/Product";
import SalarySlip from "../../images/SideBar/SalarySlip";
import TaskImg from "../../images/SideBar/Task";
import TaskSheet from "../../images/SideBar/TaskSheet";
import UserImg from "../../images/SideBar/User";
import ViewFileImg from "../../images/SideBar/viewFile";
import Calendar from "../../images/SideBar/Calendar";
import { Roles } from "../../util/constant";
import { HireIcon } from "../../images/SideBar/HiringIcon";
import Contact from "../../images/SideBar/Contact";
import VideoIcon from "../../images/SideBar/Video";
import Timer from "../../images/SideBar/Timer";
export interface IUserProfileDataItem {
  icon: JSX.Element;
  title: string;
  desc: string;
  iconColor: string;
  iconBg: string;
}

export interface INavLinkItem {
  name: string;
  icon: JSX.Element;
  link: string;
  sub?: any;
}

export interface ISidebarLinkItems {
  title: string;
  links: INavLinkItem[];
}

// Navigation configuration
const navigationItems = {
  admin: [
    {
      name: "Task Sheet",
      icon: <TaskSheet />,
      link: "taskSheet",
    },
    {
      name: "Dash Board",
      icon: <DashBoardImg />,
      link: "dashBoard",
    },
    // {
    //   name: "Calendar",
    //   icon: <Calendar />,
    //   link: "calendar",
    // },

    {
      name: "Daily Task Update",
      icon: <TaskImg />,
      link: "dailyTask",
    },
    {
      name: "Backlog",
      icon: <EmployeeImg />,
      link: "backlog",
    },
    {
      name: "Employee",
      icon: <UserImg />,
      link: "employee",
    },
    {
      name: "Project",
      icon: <ProductImg />,
      link: "project",
    },
    {
      name: "Client",
      icon: <DealerImg />,
      link: "client",
    },
    {
      name: "Contact",
      icon: <Contact />,
      link: "contact",
    },
    {
      name: "Lead",
      icon: <Lead />,
      link: "lead",
    },
    {
      name: "Leave",
      icon: <Leave />,
      link: "leave",
    },
    {
      name: "Document",
      icon: <Document />,
      link: "document",
    },
    {
      name: "Weekly Goal",
      icon: <Goal />,
      link: "WeeklyGoal",
    },
    {
      name: "Salary Slip",
      icon: <SalarySlip />,
      link: "salary-slip",
    },
    {
      name: "Holidays",
      icon: <Holiday />,
      link: "holidays",
    },
    {
      name: "Hiring Employee",
      icon: <HireIcon />,
      link: "hiring",
    },
    {
      name: "Campaign",
      icon: <HireIcon />,
      link: "campaign",
    },
    {
      name: "Video Recorder",
      icon: <VideoIcon />,
      link: "video-recorder",
    },
    {
      name: "Jibble",
      icon: <Timer />,
      link: "jibble",
    },
  ],
  employee: [
    {
      name: "Task Sheet",
      icon: <TaskSheet />,
      link: "taskSheet",
    },
    {
      name: "Daily Task Update",
      icon: <TaskImg />,
      link: "dailyTask",
    },
    {
      name: "Document",
      icon: <Document />,
      link: "document",
    },
    {
      name: "Weekly Goal",
      icon: <Goal />,
      link: "WeeklyGoal",
    },
    {
      name: "Leave",
      icon: <Leave />,
      link: "leave",
    },
    {
      name: "Holidays",
      icon: <Holiday />,
      link: "holidays",
    },
    ,
    {
      name: "Video Recorder",
      icon: <VideoIcon />,
      link: "video-recorder",
    },
    {
      name: "Jibble",
      icon: <Timer />,
      link: "jibble",
    },
    // {
    //   name: "Campaign",
    //   icon: <HireIcon />,
    //   link: "campaign",
    // },
  ],
  hr: [
    {
      name: "Task Sheet",
      icon: <TaskSheet />,
      link: "taskSheet",
    },
    {
      name: "Daily Task Update",
      icon: <TaskImg />,
      link: "dailyTask",
    },
    {
      name: "Document",
      icon: <Document />,
      link: "document",
    },
    {
      name: "Weekly Goal",
      icon: <Goal />,
      link: "WeeklyGoal",
    },
    {
      name: "Leave",
      icon: <Leave />,
      link: "leave",
    },
    {
      name: "HR Task View",
      icon: <ViewFileImg />,
      link: "hrTaskView",
    },
    {
      name: "HR Leave",
      icon: <Leave2 />,
      link: "hr-leave",
    },
    {
      name: "Salary Slip",
      icon: <SalarySlip />,
      link: "salary-slip",
    },
    {
      name: "Employee",
      icon: <UserImg />,
      link: "employee",
    },
    {
      name: "Lead",
      icon: <Lead />,
      link: "lead",
    },
    {
      name: "Holidays",
      icon: <Holiday />,
      link: "holidays",
    },
    {
      name: "Hiring Employee",
      icon: <HireIcon />,
      link: "hiring",
    },
    {
      name: "Campaign",
      icon: <HireIcon />,
      link: "campaign",
    },
    {
      name: "Video Recorder",
      icon: <VideoIcon />,
      link: "video-recorder",
    },
    {
      name: "Jibble",
      icon: <Timer />,
      link: "jibble",
    },
  ],
};

const getNavigationItems = (
  role: string | null,
  subRole: string | null
): INavLinkItem[] => {
  if (!role) return [];

  let items = [
    ...(navigationItems[role as keyof typeof navigationItems] || []),
  ];

  if (
    (role === Roles.employee && subRole === Roles.bde) ||
    (role === Roles.employee && subRole === Roles.bde_manager)
  ) {
    items.push({
      name: "Lead",
      icon: <Lead />,
      link: "lead",
    },
    {
      name: "Campaign",
      icon: <HireIcon />,
      link: "campaign",
    });
  }
  if (role === Roles.employee && subRole === Roles.tl) {
    items.push({
      name: "TL Task View",
      icon: <ViewFileImg />,
      link: "tlTaskView",
    });
  }
  // Filter out any undefined items to satisfy INavLinkItem[] typing
  return items.filter(Boolean) as INavLinkItem[];
};

const currentRole = localStorage.getItem("role");
const currentSubRole = localStorage.getItem("subRole");
const linksArray = getNavigationItems(currentRole, currentSubRole);

export const links: ISidebarLinkItems[] = [
  {
    title: "MENU",
    links: linksArray,
  },
];
